// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__olwD8","disabled":"FileBtn_disabled__31lYG","warn":"FileBtn_warn__sZe1j","fade":"FileBtn_fade__190wQ"};